(function($){
    $(document).ready(function(){

        // Infoboxes
        if( $('.info-box').length > 0 ){
            $('.info-box').each(function(){
                $(this).append("<div class='info-box__background'></div>");
            });
        }

        // Unbind parent theme's preventDefault() behavior
        $('.main-navigation li.menu-item-has-children a').not('.is-dropdown-submenu a').unbind("click");
        // mobile
        $('#menu-paanavigaatio > li.menu-item-has-children > a').unbind("click");
        $('#mobile-navigation > li.menu-item-has-children > a').unbind("click");

        var submenuParent = jQuery('.main-navigation > li.menu-item-has-children > a, #mobile-navigation > li.menu-item-has-children > a');

        jQuery(submenuParent).focus(function(){
            submenuParent.attr('aria-expanded', function(index, attr){
                return attr == 'false' ? 'true' : 'false';
            });

            submenuParent.not(this).attr('aria-expanded', 'false');
            submenuParent.not(this).next('.submenu').removeClass('js-dropdown-active');
            jQuery(this).next('.submenu').toggleClass('js-dropdown-active');

        });


        // Focus on mobile menu when toggld
        $('.hamburger').on('click', function(){
            $('#off-canvas .close-menu').focus();
        });
        $('.close-menu').on('click', function(){
            $('.hamburger').focus();
        });

        // Landingpage bg
        if( $('.landing-page__content').length > 0 ){
            var additionalPixels = 100;
            var contentHeight = $('.landing-page__content').outerHeight();
            var bgHeight = $('.diagonal-bg').height();
            // var bgHeightNew = contentHeight + bgHeight + additionalPixels;
            var bgHeightNew = contentHeight + bgHeight;

            $('.page-template-template-landingpage .pattern').css('height', bgHeightNew);
            $('.pattern').addClass('cut');
        }


        $('a').click(function(){
            var href = $(this).attr('href');

            if( href == '#palaute' ){
                var target = $(decodeURI( this.hash ));
                target = target.length ? target : $('[id=' + this.hash.slice(1) +']');

                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000);

                    target.focus(); // Setting focus

                    if (target.is(":focus")){ // Checking if the target was focused
                        return false;
                    } else {
                        target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                        target.focus(); // Setting focus
                    };

                    window.location.hash = $.attr(this, 'href').substr(1);
                    return false;
                }
            }
        });

    }); 

    if( $('.secondary-navigation .page-list').length > 0){
        $(function($){
            var num_cols = 2,
            container = $('.secondary-navigation .page-list'),
            listItem = 'li',
            listClass = 'medium-9';

            container.each(function() {
                var items_per_col = new Array(),
                items = $(this).find(listItem),
                min_items_per_col = Math.floor(items.length / num_cols),
                difference = items.length - (min_items_per_col * num_cols);

                for (var i = 0; i < num_cols; i++) {
                    if (i < difference) {
                        items_per_col[i] = min_items_per_col + 1;
                    } else {
                        items_per_col[i] = min_items_per_col;
                    }
                }

                for (var i = 0; i < num_cols; i++) {
                    $(this).append($('<div ></div>').addClass(listClass));

                    for (var j = 0; j < items_per_col[i]; j++) {
                        var pointer = 0;

                        for (var k = 0; k < i; k++) {
                            pointer += items_per_col[k];
                        }
                        $(this).find('.' + listClass).last().append(items[j + pointer]);
                    }
                }
            });
        });
    }

})(jQuery);


//Accessibility- Add required role for list items
if(jQuery('.secondary-navigation .page-list').length > 0 ){
   jQuery('.secondary-navigation .page-list li.page_item').attr('role', 'listitem');
}
